import { Button } from '@toggle/design-system';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import styles from './NoDataFound.module.scss';

export interface NoDataFoundProps {
  bannerPath: string;
  title?: string;
  description?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
  children?: ReactNode;
  className?: string;
}

export const NoDataFound = ({
  bannerPath,
  title,
  description,
  buttonLabel,
  buttonAction,
  children,
  className,
  ...rest
}: NoDataFoundProps) => {
  return (
    <div
      className={clsx(styles.emptyPortfolioWrapper, className)}
      {...rest}
    >
      <img className={styles.styledImg} src={bannerPath} />
      <span className={styles.title}>{title}</span>
      <span className={styles.description}>{description}</span>
      {buttonAction && (
        <Button
          className={styles.addAssetsButton}
          onClick={buttonAction}
          label={buttonLabel}
        />
      )}
      {children}
    </div>
  );
};
